import { render, staticRenderFns } from "./BoletoPdf.vue?vue&type=template&id=33339c74"
import script from "./BoletoPdf.vue?vue&type=script&lang=js"
export * from "./BoletoPdf.vue?vue&type=script&lang=js"
import style0 from "./BoletoPdf.vue?vue&type=style&index=0&id=33339c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports